import { DetailsListLayoutMode, IColumn, Selection, Link, IDragDropContext, IDragDropEvents, IListProps, SelectionMode, Text, CommandBar, ICommandBarItemProps, IButtonProps, IPersonaSharedProps, Persona, PersonaSize, getTheme, SearchBox, Stack, Callout, DirectionalHint, IconButton, TagPicker, IBasePickerSuggestionsProps, IInputProps, ITag, TagItemSuggestion, FontIcon, TagItem, ISuggestionsProps, ISuggestionItemProps, ISuggestionModel, TextField, ITextFieldProps, Label, Overlay, ComboBox, Dropdown, PrimaryButton, DefaultButton, SpinButton, IContextualMenuProps, ShimmeredDetailsList, FocusZone, FocusZoneTabbableElements, FontWeights, Spinner, SpinnerSize, memoizeFunction, CommandBarButton, IDropdownOption, IStackComponent, ProgressIndicator, Pivot, PivotItem, TooltipHost } from "@fluentui/react"
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../../../../../../app/Hooks"
import { getPage } from "../../../../../../../app/Pages"
import { setPage } from "../../../../../../layouts/Master/MasterLayoutSlice"
import { setTitle } from "../../../../../../common/NavHeader/NavHeaderSlice"
import { useSetInterval, useConst } from '@fluentui/react-hooks';
import { Table } from "../../../../../../common/Table/Table"
import { ApiMessage, getHeaders, getSession, PROFILE_LOGO_URL } from "../../../../../../../app/Api"
import { useId, useBoolean } from '@fluentui/react-hooks';

import * as google_protobuf_wrappers_pb from 'google-protobuf/google/protobuf/wrappers_pb'
import { BoolValue, Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb"
import { getMainTheme } from "../../../../../../../app/Themes"
import { SearchField } from "../../../../../../common/SearchField/SearchField"
import { formatDate, printComponent, normalizeKey } from "../../../../../../../app/Helpers"
import { TableState } from "../../../../../../common/Table/TableSate"
import { Message } from "../../../../../../common/Message/Message"
import { ShareBox } from "../../../../../../common/ShareBox/ShareBox"
import { GetUserTypesRequest } from "../../../../../../../repository/UserManagement/Managers/usertype_pb"
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import { SessionExpiredDialog } from "../../../../../../common/SessionExpiredDialog/SessionExpiredDialog"
import React from "react"
import { bool } from "yup"
import { updateItem, dismissMessage, removeItem, reset, resetItem, getItem, updatePrivilege } from "./RolePrivilegeDetailsPageSlice"
import { DeleteRoleRequest } from "../../../../../../../repository/UserManagement/Managers/role_pb"
import { DeleteGroupRequest, GetGroupsRequest } from "../../../../../../../repository/UserManagement/Managers/group_pb"
import { abort, getgroups } from "process"
import { Popup } from "../../../../../../common/Popup/Popup"
import { GroupsForm } from "../../../../../../forms/Management/Groups/GroupsForm"
import { FormType } from "../../../../../../forms/FormProps"
import { TextView } from "../../../../../../common/DataView/TextView"
import { ProfileView } from "../../../../../../common/DataView/ProfileView"
import { DeleteGroupMembershipRequest, GetGroupMembershipRequest } from "../../../../../../../repository/UserManagement/Managers/groupmembership_pb"
import { LinkView } from "../../../../../../common/DataView/LinkView"
import { DeleteRolePrivilegeRequest, GetRolePrivilegeRequest, UpdateRolePrivilegeRequest } from "../../../../../../../repository/UserManagement/Managers/roleprivilege_pb"
import { useReactToPrint } from "react-to-print"
import { IdentityConformationState } from "../../../../../../../app/Enums"

const shimmeredDetailsListProps: IListProps = {
    renderedWindowsAhead: 0,
    renderedWindowsBehind: 0,
};


let req: GetRolePrivilegeRequest;

let org: number = -1;

let getGroupsPromise: any;
let actionPromise: any;


const key = "management/rolePrivilege/details"
export const RolePrivilegeDetailsPage: React.FunctionComponent = () => {

    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    let { id } = useParams();
    const { hash } = useLocation();
    const [selectedKey, setSelectedKey] = useState("0");
    const [confirmationStatus, setConfirmationState] = useState<any>(undefined);

    const state: {
        isChangeStateLoading: boolean,
        message: ApiMessage | undefined,
        appTheme: string, isDarkModeEnabled: boolean,
        isLoading: boolean,
        item: any
    } = useAppSelector((state) => {
        return {
            isChangeStateLoading: state.managersRolePrivilegeDetailsPage.isChangeStateLoading,
            message: state.managersRolePrivilegeDetailsPage.message,
            appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled,
            isLoading: state.managersRolePrivilegeDetailsPage.isLoading,
            item: state.managersRolePrivilegeDetailsPage.item,

        }
    })
    const calloutTargetId = useId('callout-target');
    const labelId = useId('callout-label');
    const deleteActionConfirmationcalloutTargetId = useId('delete-action-callout-target');
    const ActionConfirmationLabelId = useId('action-callout-label');
    const shareCalloutLabelId = useId('share-callout-label');
    const shareTargetId = useId('share-callout-target');
    const confirmActionConfirmationcalloutTargetId = useId('confirm-action-callout-target');

    const [isActionConfirmationCalloutVisible, { toggle: toggleisActionConfirmationCalloutVisible }] = useBoolean(false);
    const [isShareCalloutVisible, { toggle: toggleisShareCalloutVisible }] = useBoolean(false);

    const [currentAction, setCurrenctAction] = useState(0)


    const ref = useRef<HTMLDivElement>(null);
    const reactToPrintContent = () => {
        return printComponent(ref.current?.cloneNode(true), true);
    };

    const handlePrint = useReactToPrint({});

    const getActionId = (action: number): string => {
        if (action == 1)
            return deleteActionConfirmationcalloutTargetId;
        else if (action == 2) {
            return confirmActionConfirmationcalloutTargetId;
        } else {
            return ""
        }
    }


    useEffect(() => {
        // console.log("32")
        req = new GetRolePrivilegeRequest();
        var l = searchParams.get('org');
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
                req.setOrganization(wrapper)
            }
        }
        const page = getPage(key)

        dispatch(setTitle(t(normalizeKey(page?.title))));
        dispatch(setPage(page));

        if (id) {
            let i = Number(id);
            if (Number.isNaN(id)) {
                navigate(-1)
            } else {
                req.setId(i)
                getGroupsPromise = dispatch(getItem({ body: req, headers: getHeaders() }))
            }

        } else {
            navigate(-1)
        }


        return () => { //clean up
            getGroupsPromise?.abort();
            actionPromise?.abort();
            dispatch(reset());
        }
    }, [])



    const _selectionItems: ICommandBarItemProps[] = [
        {
            key: 'back',
            text: t('back'),
            title: t('back'),
            iconProps: { iconName: 'back' },
            disabled: state.isLoading,
            onClick: () => {
                navigate(-1)
            }
        },
        {
            key: 'refresh',
            text: t('refresh'),
            title: t('refresh'),
            iconProps: { iconName: 'refresh' },
            disabled: state.isLoading,
            onClick: () => {
                dispatch(resetItem())
                getGroupsPromise = dispatch(getItem({ body: req, headers: getHeaders() }))
            }
        },
        {
            key: 'requiredProfileConfirmationLevel',
            text: t("edit"),
            title: t("edit"),
            iconProps: { id: confirmActionConfirmationcalloutTargetId, iconName: 'EditSolid12' },

            //  disabled: state.customers.selected.length > 0 && state.customers.selected.at(0)?.isProtected,

            commandBarButtonAs: (e) => {
                return <CommandBarButton {...(e as IButtonProps)} iconProps={state.isChangeStateLoading && currentAction == 2 ? undefined : e.iconProps} text={state.isChangeStateLoading && currentAction == 2 ? undefined : e.text}  >
                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isChangeStateLoading && currentAction == 2 ? "block" : "none") } }} />
                </CommandBarButton>;
            },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    var selected = state.item;
                    setConfirmationState({ key: Number(selected?.requiredProfileConfirmationLevel + ""), text: "" })
                    setCurrenctAction(2)
                    toggleisActionConfirmationCalloutVisible()
                }
            }

        },
        {
            key: 'remove',
            text: t("removeRolePrivilege"),
            title: t('removeRolePrivilege'),
            iconProps: { id: deleteActionConfirmationcalloutTargetId, iconName: "Remove", styles: { root: { fontWeight: "bold" } } },
            commandBarButtonAs: (e) => {
                return <CommandBarButton {...(e as IButtonProps)} iconProps={state.isChangeStateLoading && currentAction == 1 ? undefined : e.iconProps} text={state.isChangeStateLoading && currentAction == 1 ? undefined : e.text}  >
                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isChangeStateLoading && currentAction == 1 ? "block" : "none") } }} />
                </CommandBarButton>;
            },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(1)
                    toggleisActionConfirmationCalloutVisible()
                }
            }
        },
        {
            key: 'logs',
            text: t("logs"),
            iconProps: { iconName: "PageList", styles: { root: { fontWeight: "bold" } } },
            title: t("logs"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    navigate("/logs?resourceId=" + state.item?.id + ((org == -1) ? "" : "&org=" + org));
                }
            }
        },
        {
            key: 'share',
            text: t("share"),
            title: t('share'),
            iconProps: { id: shareTargetId, iconName: 'Share', styles: { root: { fontWeight: "bold" } } },
            onClick: () => {
                toggleisShareCalloutVisible()
            },

        },
        {
            key: 'print',
            text: t("print"),
            iconProps: { iconName: "Print", styles: { root: { fontWeight: "bold" } } },
            title: t("print"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    handlePrint(reactToPrintContent);
                }
            }
        },
    ];



    return (
        <Stack >
            {state.message != undefined ? (state.message.data != 401) ? <Message
                body={state.message.body}
                title={state.message.title}
                data={state.message.data}
                onDismiss={() => { dispatch(dismissMessage()) }}
                type={state.message.type}
            /> :
                <SessionExpiredDialog />
                : null
            }


            {isShareCalloutVisible ? (
                <Callout
                    ariaLabelledBy={shareCalloutLabelId}
                    target={`#${shareTargetId}`}
                    onDismiss={toggleisShareCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <ShareBox onDismiss={toggleisShareCalloutVisible} title={t("shareRolePrivilege")} value={`https://${window.location.host}/management/role-privileges/${state.item.id}` + ((org == -1) ? "" : "?org=" + org)}></ShareBox>
                </Callout>
            ) : null}


            {isActionConfirmationCalloutVisible ? (
                <Callout
                    ariaLabelledBy={ActionConfirmationLabelId}
                    target={`#${getActionId(currentAction)}`}
                    onDismiss={toggleisActionConfirmationCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <Stack tokens={{ padding: '20px 24px ' }}>
                        <Text block variant="xLarge" styles={{ root: { marginBottom: 12 } }}>
                            {(currentAction == 1 ? t("removeRolePrivilege") : currentAction == 2 ? t("requiredProfileConfirmationLevel") : "")}
                        </Text>
                        <Text block variant="small">
                            {(currentAction == 1 ? t("removeRolePrivilegeDesc") : currentAction == 2 ? t("requiredProfileConfirmationLevelHint") : "")}

                        </Text>

                        {currentAction == 2 ? <Stack tokens={{ childrenGap: 10 }}>
                            <Dropdown
                                label={t("confirmationStatus")}
                                selectedKey={confirmationStatus?.key}
                                options={[
                                    { key: IdentityConformationState.CONFIRMED, text: t("confirmed") },
                                    { key: IdentityConformationState.UPDATE_UNDER_REVIEW, text: t("inReview") + ", " + t("confirmed") },
                                    { key: IdentityConformationState.PENDING_CONFIRMATION, text: t("confirmationPending") + ", " + t("inReview") + ", " + t("confirmed") },

                                    { key: IdentityConformationState.UPDATE_REQURED, text: t("updateRequired") + ", " + t("confirmationPending") + ", " + t("inReview") + ", " + t("confirmed") },
                                    { key: IdentityConformationState.INFO_INVALID, text: t("invalidInfo") + ", " + t("updateRequired") + ", " + t("confirmationPending") + ", " + t("inReview") + ", " + t("confirmed") },
                                    {
                                        key: IdentityConformationState.NOT_CONFIRMED,
                                        text: t("all")
                                    }]}
                                onChange={((e: React.FormEvent<HTMLDivElement>, item?: IDropdownOption) => {
                                    (setConfirmationState({ key: Number(item?.key), text: "" }))
                                })}
                            />


                        </Stack> : undefined}
                        {/* This FocusZone allows the user to go between buttons with the arrow keys.
              It's not related to or required for FocusTrapCallout's built-in focus trapping. */}
                        <FocusZone handleTabKey={FocusZoneTabbableElements.all} isCircularNavigation>
                            <Stack reversed tokens={{ childrenGap: 8, padding: "20px 0px 0px 0px" }} horizontal>
                                <DefaultButton autoFocus onClick={toggleisActionConfirmationCalloutVisible}>{t("cancel")}</DefaultButton>

                                <PrimaryButton onClick={() => {
                                    toggleisActionConfirmationCalloutVisible()
                                    if (state.item) {
                                        if (currentAction == 1) {
                                            let req = new DeleteRolePrivilegeRequest();
                                            req.setId(state.item.id)
                                            if ((org != -1)) {
                                                const r = new Int32Value();
                                                r.setValue(org)
                                                req.setOrganization(r)
                                            }

                                            actionPromise?.abort();
                                            actionPromise = dispatch(removeItem({ body: req, headers: getHeaders() }))
                                            actionPromise.unwrap().then((e: any) => {
                                                navigate(-1)
                                            })
                                        } else if (currentAction == 2) {
                                            let req = new UpdateRolePrivilegeRequest();
                                            req.setId(state.item.id)
                                            req.setRequiredprofileconfirmationlevel(confirmationStatus.key)
                                            actionPromise = dispatch(updatePrivilege({ body: req, headers: getHeaders() }))
                                            actionPromise.unwrap().then((e: any) => {
                                                setConfirmationState(undefined)
                                            })

                                        }
                                    }


                                }} text={(currentAction == 1 ? t("remove") : currentAction == 2 ? t("update") : "")}  >

                                </PrimaryButton>
                            </Stack>
                        </FocusZone>
                    </Stack>
                </Callout>
            ) : null}



            {state.isLoading ? <ProgressIndicator /> :

                !state.item ? null :
                    <div ref={ref}>
                        <CommandBar
                            items={_selectionItems}
                        />
                        <Stack tokens={{ childrenGap: 10, padding: "0px 33% 10px 3%" }}>

                            <Stack horizontal tokens={{ childrenGap: 10 }}>

                                <TextView label={t("id")} value={state.item?.id} />


                                <TextView label={t("createdDate")} value={state.item?.createdDate} />

                                {state.item?.addedBy ? <ProfileView label={t("addedBy")} value={state.item?.addedBy == "" ? state.item?.addedById : state.item?.addedBy}
                                    url={"/management/users/" + state.item?.addedById + ((org == -1) ? "" : "?org=" + org)}
                                    text={state.item?.addedBy == "" ? state.item?.addedById : state.item?.addedBy}
                                    imageUrl={PROFILE_LOGO_URL + "/" + getSession()?.organization?.id + "/" + state.item?.addedById + "/profile.jpg"}

                                    size={PersonaSize.size40} />

                                    : undefined}

                            </Stack>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                                <LinkView label={t("role")} value={state.item?.roleName}
                                    url={"/management/roles/" + state.item?.roleId + ((org == -1) ? "" : "?org=" + org)} />

                                <LinkView label={t("privilege")} value={state.item?.privilegeName}
                                    url={"/management/privileges/" + state.item?.privilegeId + ((org == -1) ? "" : "?org=" + org)} />


                            </Stack>

                            <TooltipHost
                                content={t("requiredProfileConfirmationLevelHint")}
                            >
                                <TextView label={t("requiredProfileConfirmationLevel")} value={state.item?.requiredProfileConfirmationLevel == IdentityConformationState.INFO_INVALID ? "" + t("invalidInfo")
                                    + ", " + t("updateRequired") + ", " + t("confirmationPending") + ", " + t("inReview") + ", " + t("confirmed") :
                                    state.item?.requiredProfileConfirmationLevel == IdentityConformationState.UPDATE_UNDER_REVIEW ? "" + t("inReview") + ", " + t("confirmed") :
                                        state.item?.requiredProfileConfirmationLevel == IdentityConformationState.PENDING_CONFIRMATION ? "" + t("confirmationPending") + ", " + t("inReview") + ", " + t("confirmed") :

                                            state.item?.requiredProfileConfirmationLevel == IdentityConformationState.UPDATE_REQURED ? "" + t("updateRequired") + ", " + t("confirmationPending") + ", " + t("inReview") + ", " + t("confirmed") :
                                                state.item?.requiredProfileConfirmationLevel == IdentityConformationState.CONFIRMED ? t("confirmed") :
                                                    ("" + t("unconfirmed") + ", " + t("invalidInfo")
                                                        + ", " + t("updateRequired") + ", " + t("confirmationPending") + ", " + t("inReview") + ", " + t("confirmed"))}></TextView>
                            </TooltipHost>

                        </Stack>
                    </div>


            }


        </Stack>



    );
}




